import { getData } from "../../../../newApis/dotNetApiMethods";
import * as ajaxEndpoints from "../../../../api/ajax-endpoints";
import { useQuery } from "react-query";

const getEducationalQualifications = async () => {
  const data = await getData(`${ajaxEndpoints.EDUCATIONAL_QUALIFICATION}`);
  return data;
};

export default function useEducationalQualifications() {
  return useQuery(
    ["getEducationalQualifications"],
    getEducationalQualifications,
    {
      refetchOnWindowFocus: false,
    },
  );
}
